import { useStytchMemberSession } from "@stytch/react/b2b";
import { Navigate } from "react-router-dom";

const Fallback = () => {
  const { session } = useStytchMemberSession();

  if (session) {
    return <Navigate to={`/funnel`} />;
  }

  return <Navigate to={`/auth/login`} />;
};

export default Fallback;
